import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import Radio from '@mui/material/Radio';
import cx from 'classnames';
import InputLabel from '@mui/material/InputLabel';
import styles from '@/common/components/Inputs/RadioGroup/styles.less';
import { ReactBB } from '@/common/utils/index';

const RadioGroup = ({ name, options = [], tip, rules, ...props }) => {
  const { control } = useFormContext() || {};

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field: { onChange, value, name }, fieldState: { error } }) => {
        return (
          <div className={styles.container}>
            <div className={styles.groupWrap}>
              {options.map(({ value: selfValue, label }, index) => (
                <div key={selfValue} className={styles.inputWrap}>
                  <Radio
                    className={cx(error && styles['label-error'])}
                    checked={selfValue === value}
                    onChange={onChange}
                    value={selfValue}
                    name={name}
                    inputProps={{
                      id: `${name}-${index}`,
                      ...props.inputProps,
                      ['data-testid']: `${name}.${index}`,
                    }}
                  />
                  <InputLabel className={styles.label} htmlFor={`${name}-${index}`}>
                    {ReactBB(label)}
                  </InputLabel>
                </div>
              ))}
            </div>
            <InputLabel
              className={cx(
                styles.bottomLabel,
                !!error && styles['bottomLabel-error']
              )}
              htmlFor={name}
            >
              {error?.message || tip}
            </InputLabel>
          </div>
        );
      }}
    />
  );
};

export default RadioGroup;
